<template>
  <section
    id="home"
    class="relative h-screen flex items-center bg-gradient-to-b from-blueberry-lighter/20 to-background"
  >
    <div class="absolute inset-0 bg-blueberry-pattern opacity-40"></div>

    <div class="container mx-auto px-4 md:px-6 relative z-10">
      <div
        class="flex flex-col items-center md:items-start text-center md:text-left max-w-3xl md:ml-10 lg:ml-20"
      >
        <!-- Logo + title grouped so logo centers over the title text -->
        <div class="flex flex-col items-center mb-4">
          <picture>
            <source srcset="/logogrube.avif" type="image/avif" />
            <img
              src="/logogrube.png"
              alt="Borówka Amerykańska Logo"
              width="416"
              height="416"
              fetchpriority="high"
              class="w-64 md:w-64 mb-6 md:mb-8 animate-fade-in"
            />
          </picture>
          <h1
            class="text-4xl md:text-5xl lg:text-6xl font-bold text-navy leading-tight animate-fade-in"
          >
            {{ t('hero.title') }} <span class="text-blueberry">{{ t('hero.titleHighlight') }}</span>
          </h1>
        </div>
        <p
          class="text-lg md:text-xl text-foreground/80 mb-8 max-w-2xl animate-fade-in"
        >
          {{ t('hero.subtitle') }}
        </p>
        <div class="flex flex-col sm:flex-row gap-4 animate-fade-in">
          <OrderGateLink class="btn-primary px-8 py-3 text-lg">
            {{ t('hero.orderNow') }}
          </OrderGateLink>
          <RouterLink
            class="border-2 border-blueberry text-blueberry hover:bg-blueberry hover:text-white font-semibold py-3 px-8 rounded-lg transition-colors duration-200 text-lg"
            :to="aboutRoute"
          >
            {{ t('hero.explorePlantation') }}
          </RouterLink>
        </div>
      </div>
    </div>

    <div
      class="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce"
    >
      <ChevronDown :size="36" class="text-blueberry" />
    </div>
  </section>
</template>

<script setup lang="ts">
import { ChevronDown } from "lucide-vue-next";
import { aboutRoute } from "@/router/navigation";
import { useI18n } from "vue-i18n";
import OrderGateLink from "@/components/OrderGateLink.vue";

const { t } = useI18n();
</script>
